module.exports = __webpack_public_path__ + "static/img/free-bg.7380b5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bts-2026-sale/free-bg.png
// module id = +0Yj
// module chunks = 2